/** @type {Record<string, string>} */
import esHelpDev from './es.helpDev';
import esDeviceTrust from './es.deviceTrust';
import esAuth from './es.auth';
import esPlays from './es.plays';
import esInbox from './es.inbox';
import { staffOnboardingEs } from './staffOnboarding';
import { platformSessionEs } from './platformSession';
import { emailAdminEs } from './emailAdmin';

const es = {
  welcomeBack:'Bienvenido.', signIn:'Entrar', enter:'Entrar',
  authFormTitle:'Inicia sesión',
  appTagline:'Corre los números.',
  documentTitle:'Alea-Tui: corre los números',
  heroTitleLead:'Corre los', heroTitleAccent:'números.',
  signingIn:'Entrando…',
  loadingWorkspace:'Cargando espacio de trabajo…',
  updatingHouseContext:'Actualizando contexto de casa…',
  workspaceLoadError:'No se pudo cargar el espacio de trabajo. Revisa la conexión e inténtalo de nuevo.',
  username:'Usuario', password:'Contraseña',
  usernameHint:'Tu correo o usuario',
  passwordHint:'Tu contraseña de acceso',
  demoAccounts:'cuentas demo',
  continueWithGoogle:'Continuar con Google',
  continueWithApple:'Continuar con Apple',
  continueWithFacebook:'Continuar con Facebook',
  continueWithMicrosoft:'Continuar con Microsoft',
  biometricSignIn:'Desbloquear con {type}',
  biometricRetry:'Reintentar con {type}',
  biometricGeneric:'biometría',
  rememberUser:'Recordarme',
  forgotPassword:'¿Olvidaste la contraseña?',
  forgotPasswordTitle:'Restablecer contraseña',
  forgotPasswordHint:'Te enviaremos un enlace seguro para crear una nueva contraseña.',
  forgotPasswordSend:'Enviar enlace',
  forgotPasswordSending:'Enviando…',
  forgotPasswordSent:'Si existe una cuenta con ese usuario, el correo de restablecimiento está en camino. Revisa tu bandeja.',
  forgotPasswordError:'No se pudo enviar el correo. Verifica el usuario e inténtalo de nuevo.',
  forgotPasswordBack:'Volver al inicio de sesión',
  biometricLoginTitle:'Desbloqueo biométrico',
  biometricLoginDesc:'Usa Face ID, huella o biometría del dispositivo en este equipo.',
  biometricEnable:'Activar {type}',
  biometricDisable:'Desactivar biometría',
  biometricEnabled:'Desbloqueo biométrico activado en este dispositivo.',
  biometricDisabled:'Desbloqueo biométrico desactivado.',
  biometricEnablePrompt:'Introduce tu contraseña para guardar el desbloqueo biométrico en este dispositivo.',
  biometricLoginPlatform:'Acceso biométrico',
  biometricLoginPlatformDesc:'Permite desbloquear credenciales guardadas con biometría del dispositivo cuando esté disponible.',
  mfaSmsPrompt:'Introduce el código SMS de 6 dígitos enviado a tu teléfono.',
  mfaEmailPrompt:'Introduce el código de 6 dígitos enviado a {email}.',
  mfaEmailPromptRequest:'Pulsa Enviar código para recibir un código de 6 dígitos en {email}.',
  mfaEmailFallback:'tu correo',
  mfaEmailEnrollPrompt:'Enviamos un código a {email}. Introdúcelo para activar MFA por correo.',
  mfaEmailSent:'Código de verificación enviado a tu correo.',
  mfaSmsSent:'Código de verificación enviado por SMS.',
  mfaResend:'Reenviar código',
  mfaSendCode:'Enviar código',
  mfaSmsPhoneHint:'+1 555 123 4567',
  mfaMethodsTitle:'Métodos de dos factores',
  mfaMethodTotp:'App autenticadora',
  mfaMethodTotpDesc:'Usa Google Authenticator, Authy u otra app TOTP.',
  mfaMethodSms:'SMS',
  mfaMethodSmsDesc:'Recibe códigos de un solo uso por mensaje de texto.',
  mfaMethodEmail:'Verificación por correo',
  mfaMethodEmailDesc:'Recibe códigos de un solo uso por correo electrónico.',
  platformAuthSection:'Proveedores de acceso',
  platformAuthSectionHint:'Activa proveedores OAuth alternativos. Cada uno requiere configuración en Firebase antes de usarse.',
  platformMfaSection:'Métodos MFA',
  platformMfaSectionHint:'Elige qué métodos de segundo factor pueden activar los usuarios.',
  authProviderGoogle:'Google',
  authProviderGoogleDesc:'Acceso con cuentas de Google.',
  authProviderApple:'Apple',
  authProviderAppleDesc:'Acceso con Apple ID (requiere configuración en Apple Developer).',
  authProviderFacebook:'Facebook',
  authProviderFacebookDesc:'Acceso con Facebook (requiere app en Meta).',
  authProviderMicrosoft:'Microsoft',
  authProviderMicrosoftDesc:'Acceso con Microsoft / Azure AD (requiere configuración del tenant).',
  linkAccountTitle:'Vincular cuenta',
  linkAccountHint:'Este correo ya está registrado. Entra con tu contraseña para vincular Google.',
  mfaTitle:'Autenticación en dos pasos',
  mfaPrompt:'Introduce el código de 6 dígitos de tu app autenticadora.',
  mfaVerify:'Verificar',
  cancel:'Cancelar',
  accountSecurity:'Cuenta y seguridad',
  signedInAs:'Sesión iniciada como',
  linkedProviders:'Métodos de acceso vinculados',
  linkGoogle:'Cuenta de Google',
  linkGoogleHint:'Vincula Google para entrar más rápido en este dispositivo.',
  link:'Vincular',
  unlink:'Desvincular',
  googleLinked:'Cuenta de Google vinculada.',
  googleUnlinked:'Cuenta de Google desvinculada.',
  unlinkNeedsPassword:'Añade acceso con contraseña antes de desvincular Google.',
  mfaOn:'MFA activado',
  mfaOff:'MFA desactivado',
  mfaEnable:'Activar MFA',
  mfaDisable:'Desactivar MFA',
  mfaEnabled:'MFA activado correctamente.',
  mfaDisabled:'MFA desactivado.',
  mfaRequiresRecentLogin:'Confirma tu contraseña otra vez para cambiar MFA.',
  mfaReauthPrompt:'Introduce tu contraseña para continuar activando MFA.',
  mfaTotpEmulatorUnavailable:'La app autenticadora no está disponible en la demo local. Usa MFA por correo, o un proyecto Firebase en vivo.',
  mfaScanQr:'Escanea este QR en tu app autenticadora, luego introduce el código.',
  mfaOpenQr:'Abrir enlace de configuración QR',
  mfaManualKey:'O introduce esta clave manualmente en tu app autenticadora:',
  transportSecurityTitle:'Seguridad de la conexión',
  transportSecurityDesc:'Conexión cifrada.',
  transportSecurityDetails:'Tu sesión y tus datos viajan protegidos entre tu dispositivo y nuestros servidores. Usa una contraseña fuerte y activa la autenticación en dos pasos cuando puedas. Para temas de cuenta, contacta soporte desde Ayuda.',
  transportSecurityBadge:'Cifrada',
  accountSecurityUnavailable:'Acceso básico en esta sesión.',
  accountSecurityUnavailableDetails:'Las opciones adicionales de acceso no están disponibles ahora. Si necesitas ayuda con tu cuenta, contacta soporte desde Ayuda.',
  moreInfo:'Más info',
  lessInfo:'Menos',

  online:'En línea', offline:'Sin conexión', serverUnreachable:'Servidor no disponible',
  simulatedOffline:'Modo sin conexión simulado (solo desarrollo)', simulatedOfflineShort:'sim',
  queued:'en cola', pending:'pendientes',

  settings:'Ajustes', logout:'Salir', userMenu:'Cuenta', language:'Idioma', theme:'Tema',
  userMenuProfile:'Perfil', userMenuAgreements:'Acuerdos y comisiones',
  profile:'Perfil', profileName:'Nombre', profileEmail:'Correo', profileRole:'Rol',
  profileNameSave:'Guardar nombre', profileNameSaved:'Nombre actualizado',
  profileNameRequired:'Escribe un nombre.', profileNameTooLong:'El nombre es demasiado largo.',
  profileSaving:'Guardando…', profileSaved:'Guardado', profileLoading:'Cargando perfil…',
  profileChangePhoto:'Cambiar foto',
  profileMediaNeedsHouse:'Necesitas una casa asignada para subir fotos.',
  agreementsTitle:'Acuerdos y comisiones',
  agreementsListerIntro:'Acuerdo con el banquero sobre el % que recibes por facilitar jugadas y recoger apuntes de terceros.',
  agreementsRunnerIntro:'Acuerdo con el banquero sobre el % que recibes por recoger colectas en los puntos de listas asignados.',
  agreementsWithBanker:'Acuerdo con la banca',
  agreementsRate:'Porcentaje acordado', agreementsRateShort:'sobre colectas',
  agreementsVolume:'Volumen en jugadas', agreementsVolumeListerHint:'Total recogido en apuntes, sin contar premios de sorteo.',
  agreementsVolumeRunnerHint:'Dinero recogido en paradas completadas.',
  agreementsEarnings:'Ganancias', agreementsEarningsHint:'Comisión calculada sobre el volumen recogido.',
  agreementsCommissions:'Comisiones', agreementsPending:'Pendiente de recoger',
  agreementsPotential:'Comisión potencial', agreementsByShift:'Por turno',
  agreementsUnavailable:'No hay acuerdos disponibles para tu rol.',
  light:'Claro', dark:'Oscuro', system:'Sistema',

  dayWindow:'Turno diurno', nightWindow:'Turno nocturno',
  dayShift:'Turno diurno', nightShift:'Turno nocturno',
  playWindows:'Espera de resultados', shiftOpen:'Inicio', shiftClose:'Cierre',
  cutoffBuffer:'Margen de cierre', cutoffHint:'No se aceptan jugadas en el minuto de cierre ni después (incluido justo al cierre).',
  overnightWindowHint:'El turno día suele cruzar medianoche: se acepta desde el fin del bloque noche hasta el inicio del bloque día.',
  sourceWindowsHint:'Florida y Nueva York fijan el bloqueo desde la hora oficial del sorteo (Eastern) convertida a Cuba. Cambia el origen para recalcular.',
  perNumberCap:'Tope por número ($)', lotterySource:'Sorteo',
  limitsSection:'Límites', sourceSection:'Fuente',
  floridaScheduleHint:'Florida (ET): mediodía {middayDraw} · noche {eveningDraw}. Bloqueo Cuba hoy: día hasta {cubaDayClose}, noche hasta {cubaNightClose}.',
  autoFloridaSync:'Sincronización automática Florida',
  autoFloridaSyncHint:'Si está activa, los sorteos de mediodía y noche se publican automáticamente en esta casa.',
  newYorkScheduleHint:'Nueva York (ET): mediodía {middayDraw} · noche {eveningDraw}. Bloqueo Cuba hoy: día hasta {cubaDayClose}, noche hasta {cubaNightClose}.',
  autoNewYorkSync:'Sincronización automática Nueva York',
  autoNewYorkSyncHint:'Si está activa, Numbers y Win 4 de mediodía y noche se publican automáticamente en esta casa.',
  georgiaManualHint:'Georgia Cash 3 / Cash 4 es solo manual por ahora: publica día/noche desde Resumen. Aún no hay sincronización automática.',
  publishResultsWindow:'Publicando turno {window}',
  resultsSubmitted:'Resultado enviado',
  resultsPending:'Faltan {count} confirmación(es) de otro banquero.',
  resultsConfirmed:'Resultados de {window} confirmados y jugadas liquidadas.',
  resultsDisputed:'Hay resultados en conflicto. Revísalos antes de liquidar.',
  error_shift_order:'Revisa los horarios: el inicio debe ser antes del cierre en cada turno.',
  error_night_before_day:'El turno nocturno debe empezar después del cierre del turno diurno.',
  configReadOnly:'Solo el banquero o administrador pueden cambiar estos horarios.',
  routeDepartSection:'Salida a recoger',
  routeDepartMode:'Modo de autorización',
  routeDepartModeManual:'Manual (autoriza el banker)',
  routeDepartModeScheduled:'Programada (auto a la hora + margen aleatorio)',
  routeDepartAt:'Hora programada (Cuba)',
  routeDepartMarginMin:'Margen aleatorio (minutos después)',
  routeDepartHint:'Hasta autorizar la salida, el runner no puede confirmar montos y el lister no puede confirmar la entrega.',
  closesIn:'Cierra en', open:'Abierto', closed:'Cerrado', awaitingResults:'Esperando resultados',

  plays:'Jugadas', newPlay:'Nueva jugada', newplay:'Jugar', number:'Número', amount:'Monto', type:'Tipo',
  fijo:'Fijo', corrido:'Corrido', parle:'Parlé', centena:'Centena',
  submit:'Jugar', recentPlays:'Jugadas recientes', noPlays:'Sin jugadas.', wager:'Apuesta',
  potential:'potencial', stake:'Apuesta',
  sessionGhostLedger:'Jugadas recién aceptadas',
  guaranteeTickets:'Avales de jugada',
  playWarrantsHint:'Di al cliente el código del Aval; con ese reclama si gana.',
  resultsAwaitingHint:'El sorteo oficial aparece aquí cuando esté disponible.',
  resultsPendingDraw:'Ya tienes una jugada ganadora — el sorteo se verá aquí al publicarse.',
  resultsToday:'En curso',
  resultsWeek:'Esta semana',
  resultsWeekEmpty:'Sin sorteos publicados recientemente.',
  resultsFeedFailed:'No se pudieron cargar los resultados.',
  resultsFeedFailedHint:'Revisa tu conexión e inténtalo de nuevo. En redes lentas puede tardar más de un minuto. Si sigue fallando, contacta soporte.',
  resultsArchived:'Anteriores',
  resultsArchivedEmpty:'Sin sorteos anteriores.',
  resultsHistory:'Historial',
  resultsHistoryEmpty:'Aún no hay sorteos registrados.',
  resultsHistoryLoading:'Cargando sorteos anteriores…',
  resultsHistoryOrigin:'Inicio del registro',
  playTypesLegendTitle:'Cómo gana cada tipo de jugada',
  playTypeRuleFijo:'Coincide con el fijo (primera posición de la corrida).',
  playTypeRuleCorrido:'Coincide con cualquiera de las tres posiciones.',
  playTypeRuleParle:'Ambos números aparecen en la corrida (cualquier orden).',
  playTypeRuleCentena:'Los dos últimos dígitos del número de 3 cifras coinciden con el fijo.',
  resultCorrida:'Corrida',
  drawPublicationTitle:'Ventanas típicas de publicación',
  drawPublicationHint:'Rangos en hora Cuba en que suelen salir Miami, Georgia y Nueva York. Las ventanas de aceptación de la casa pueden diferir.',
  drawPublicationDisclaimer:'Los resultados pueden retrasarse si la fuente oficial se retrasa.',
  drawFeedMiami:'Miami (Florida)',
  drawFeedGeorgia:'Georgia',
  drawFeedNewYork:'Nueva York',
  drawSourceTip:'Origen del sorteo',
  drawSlotMidday:'Mediodía',
  drawSlotEvening:'Tarde',
  drawSlotNight:'Noche',
  yourWinsInDraw:'Tus premios en este sorteo',
  houseWinsInDraw:'Ganadores de este sorteo',
  totalToPay:'Total a pagar',
  viewPlays:'Ver jugadas',
  viewDraw:'Ver sorteo',
  viewDrawOnYoutube:'Ver en YouTube',
  viewPrize:'Ver premio',
  error_window_closed:'Ventana cerrada — no se aceptan jugadas ahora.',
  error_invalid_type:'Tipo de jugada inválido.',
  error_invalid_number:'Número inválido para este tipo.',
  error_invalid_number2:'Segundo número inválido para parlé.',
  error_parle_same_numbers:'Los números del parlé deben ser distintos.',
  error_invalid_stake:'Introduce un monto válido.',
  error_stake_exceeds_cap:'El monto supera el tope permitido para este número.',
  error_number_cap_exceeded:'Este número alcanzó el límite de exposición de la ventana.',
  error_number_cap_override:'Este número tiene un tope del banquero que se excedería.',
  error_number_surge_cap:'Demasiadas jugadas a este número — límites de saturación activos.',

  err_generic:'Algo salió mal. Intenta de nuevo.',
  err_generic_hint:'Si sigue pasando, pide ayuda a quien administra la casa.',
  err_offline:'Sin conexión a internet.',
  err_offline_hint:'Revisa el Wi‑Fi o los datos móviles e intenta otra vez.',
  screenLoadFailed:'No se pudo cargar esta pantalla.',
  screenLoadFailedHint:'Revisa la conexión e intenta otra vez.',
  screenLoadRetry:'Reintentar',
  err_server_unreachable:'No podemos conectar con el servidor.',
  err_server_unreachable_hint:'Espera un momento e intenta de nuevo.',
  err_permission_denied:'No puedes hacer esto.',
  err_permission_denied_hint:'Pide acceso a quien administra la casa.',
  err_auth_required:'Vuelve a iniciar sesión.',
  err_auth_required_hint:'Tu sesión pudo haber terminado.',
  err_not_found:'No encontramos eso.',
  err_conflict:'Esto ya cambió. Actualiza la pantalla e intenta otra vez.',
  err_rate_limit:'Demasiados intentos. Espera un momento.',
  err_external_service:'Un servicio externo está ocupado. Intenta pronto.',
  err_config_save_failed:'No se guardaron los ajustes.',
  err_config_save_failed_hint:'Revisa tu conexión e intenta otra vez.',
  err_play_failed:'La jugada no fue aceptada.',
  err_play_failed_hint:'Revisa el número, el monto y el horario de jugadas.',

  surgePlayThreshold:'Saturación tras (jugadas)',
  surgeCapRatio:'Ratio de tope en saturación',

  results:'Resultados', publishResults:'Publicar resultados',
  publish:'Publicar', published:'Publicado',
  firstPrize:'1ro', secondPrize:'2do', thirdPrize:'3ro',
  housePlatformConflictTitle:'Plataforma vs resultados de la casa',
  housePlatformConflictHint:'La plataforma recuperó números oficiales distintos a tu publicación provisional. La pantalla siempre muestra la plataforma. Decide si el cierre sigue a la plataforma o mantiene los de la casa.',
  housePlatformConflictHouse:'Casa (provisional)',
  housePlatformConflictPlatform:'Plataforma (verdad)',
  housePlatformConflictSync:'Sincronizar con plataforma',
  housePlatformConflictKeep:'Mantener resultados de la casa',
  housePlatformConflictFailed:'No se pudo resolver el conflicto.',

  overview:'Resumen', tabsMore:'Más pestañas', navPrimary:'Navegación principal',
  netPosition:'Posición neta', earned:'Ganado',
  inLabel:'Entra', outLabel:'Sale',

  users:'Usuarios', listersUnder:'Listeros', runnersUnder:'Recogedores', bankersUnder:'Banqueros', noUsers:'Sin usuarios.',
  usersKicker:'Directorio',
  usersHint:'Personal por casa: alta, pagos, sanciones y dispositivos.',
  usersRoster:'Plantilla',
  usersActive:'Activos',
  usersSuspended:'Suspendidos',
  usersEmptyHint:'Registra el primer usuario o cambia el filtro de casa.',
  usersByHouseHint:'Banqueros, listeros y recogedores agrupados por casa.',
  alsoServes:'También en', supportStaff:'Equipo de soporte', supportStaffHint:'Roles técnicos y ayuda — rama separada de las casas.',
  userSuspend:'Suspender', userLift:'Levantar sanción', userSuspended:'Usuario suspendido', userSanctionLifted:'Sanción levantada',
  userRegister:'Registrar usuario', userRegisterForHouse:'Registrar en esta casa',
  userRegisterNeedsHouse:'Selecciona una casa primero',
  userRegisterNeedsHouseHint:'Enfoca una casa y luego registra personal en esa casa.',
  userMessage:'Mensaje', userPayment:'Pago y comisión', userAgreements:'Acuerdos por servicio',
  userEdit:'Editar usuario', userEditSave:'Guardar cambios', userEditSaved:'Usuario actualizado',
  userDelete:'Eliminar usuario', userDeleteConfirm:'Esto elimina permanentemente la cuenta. ¿Continuar?',
  userRegistered:'Usuario registrado', userDeleted:'Usuario eliminado',
  userPaymentMode:'Modo de pago', userPaymentSave:'Guardar pago', userPaymentSaved:'Pago guardado',
  userName:'Nombre', userEmail:'Correo', userRole:'Rol',
  paymentCash:'Efectivo', paymentTransfer:'Transferencia', paymentMobile:'Pago móvil',
  activeHouse:'Casa',
  platformScope:'Plataforma',
  platformScopeField:'Ámbito',

  collected:'Cobrado',
  optimize:'Optimizar',
  listView:'Lista', mapView:'Mapa', stop:'Parada',
  endRound:'— Fin de ronda —', routes:'Ruta', routesRemaining:'restantes', collections:'Rondas',

  config:'Configuraciones', configTab:'Configs', saveChanges:'Guardar cambios', saved:'Guardado',

  descSearch:'Buscar por charada',
  charadaPlaceholder:'tigre, caballo, muerto…',
  charadaMeaning:'Charada', charadaSearch:'Buscar charada',
  notFound:'Sin coincidencias.',

  role_god:'super_admin', role_banker:'Banquero', role_lister:'Listero', role_runner:'Recogedor', role_support_agent:'Soporte',
  godModeActive:'Modo Dios',

  ...esHelpDev,
  ...esDeviceTrust,
  ...esAuth,
  ...esPlays,
  ...esInbox,
  ...staffOnboardingEs,
  ...platformSessionEs,
  ...emailAdminEs,
};

export default es;
